module.exports = __webpack_public_path__ + "static/media/bodycon-dress.2b586f68.jpg";